import { computed, ref, onMounted } from 'vue'

export default {
    name: 'SimpleCard',
    props: {
        result: {
            type: Object,
            required: true
        }
    },
    setup(props) {

        const isInternalLink = computed(() => 
            props.result.isInternalLink 
                ?? props.result.url?.startsWith(location.origin)
        )

        return {
            isInternalLink: isInternalLink
        }
    }
}
